import { configureStore } from '@reduxjs/toolkit';
import { createApi } from '@/api/createApi';
import { tablesApi } from '@/api/tablesApi';
import { toolsApi } from '@/api/toolsApi';
import {
  activeStudioDocumentChanged,
  studioDocumentReducer,
} from '@/features/tools-app/studio-document-slice';

export const store = configureStore({
  reducer: {
    studioDocument: studioDocumentReducer,
    [createApi.reducerPath]: createApi.reducer,
    [tablesApi.reducerPath]: tablesApi.reducer,
    [toolsApi.reducerPath]: toolsApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // PDF bytes are an intentional immutable Uint8Array snapshot. Keeping
        // that binary value avoids base64 inflation while the Studio is open.
        ignoredActions: [activeStudioDocumentChanged.type],
        ignoredPaths: ['studioDocument.active.bytes'],
      },
    }).concat(
      tablesApi.middleware,
      createApi.middleware,
      toolsApi.middleware,
    ),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
